import { Help } from '@mui/icons-material';
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  List,
  ListItemText,
  Typography,
} from '@mui/material';
import React, { useState, type Dispatch, type SetStateAction } from 'react';
import { ILegalClientFullObject } from '../Interfaces/ILegalClient';

interface IProps {
  formValues: ILegalClientFullObject;
  setFormValues: Dispatch<SetStateAction<ILegalClientFullObject>>;
}

export const LegalClientUserForm: React.FC<IProps> = ({
  formValues,
  setFormValues,
}) => {
  const [isOpenHelpEmail, setIsOpenHelpEmail] = useState(false);

  return (
    <>
      <Dialog open={isOpenHelpEmail} onClose={() => setIsOpenHelpEmail(false)}>
        <DialogTitle>Hilfe zum Empfang von E-Mails</DialogTitle>
        <DialogContent>
          Der Empfang von E-Mails bestimmt, ob der Mandant Nachrichten aus
          Vorgängen erhält. Diese Nachrichten informieren den Mandanten über
          verschiedene wichtige Ereignisse, wie zum Beispiel angepasste
          Maßnahmen, hochgeladene Urkunden oder hinterlegte Kommentare.
          <List>
            <ListItemText>
              Standard: Wenn das Konto neu erstellt wird, ist der Empfang von
              E-Mails ausgeschaltet. Das bedeutet, dass der Mandant zunächst
              keine E-Mails aus Vorgängen bekommen.
            </ListItemText>
            <ListItemText>
              Automatische Aktivierung: Sobald der Mandant sich das erste Mal im
              Mandantenportal anmelden, wird der Empfang von E-Mails automatisch
              eingeschaltet.
            </ListItemText>
          </List>
          Hinweis: Sie können den Empfang von E-Mails jederzeit manuell
          anpassen, falls der Mandant entscheiden, dass er keine E-Mails mehr
          erhalten möchten.
        </DialogContent>
        <DialogActions>
          <Button variant='contained' onClick={() => setIsOpenHelpEmail(false)}>
            Okay
          </Button>
        </DialogActions>
      </Dialog>
      <Grid item xs={12}>
        <Collapse
          in={
            formValues.idLegalClientType === 1 &&
            formValues.Email?.includes('@')
          }
        >
          <Card variant='outlined'>
            <Typography sx={{ ml: 1 }} variant='caption'>
              Mandantenportal
            </Typography>

            <CardContent>
              {formValues.last_login_at != undefined && (
                <Typography sx={{ float: 'right', mt: -4 }}>
                  Letzter Login:{' '}
                  {new Date(formValues.last_login_at).toLocaleString()}
                </Typography>
              )}
              <Grid container>
                <Grid item xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={formValues.idLegalClient < 0}
                        inputProps={{ 'aria-label': 'controlled' }}
                        checked={formValues.isReceivingEmailEnabled}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          setFormValues({
                            ...formValues,
                            isReceivingEmailEnabled: event.target.checked,
                          });
                        }}
                      />
                    }
                    label='E-Mails empfangen'
                  />
                  <IconButton onClick={() => setIsOpenHelpEmail(true)}>
                    <Help />
                  </IconButton>
                </Grid>

                <Grid item xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        inputProps={{ 'aria-label': 'controlled' }}
                        disabled={formValues.idLegalClient < 0}
                        checked={
                          formValues.idLegalClient < 0
                            ? formValues.loginPossible
                            : formValues.resetPassword === undefined
                              ? false
                              : formValues.resetPassword
                        }
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          if (event.target.checked) {
                            setFormValues({
                              ...formValues,
                              resetPassword: true,
                              passwordResetRequired: true,
                              loginPossible: true,
                            } as ILegalClientFullObject);
                          } else {
                            setFormValues({
                              ...formValues,
                              resetPassword: false,
                            } as ILegalClientFullObject);
                          }
                        }}
                      />
                    }
                    label='Neues Passwort generieren'
                  />
                </Grid>
                <Grid item xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={
                          formValues.idLegalClient < 0 ||
                          (formValues.resetPassword !== undefined &&
                            formValues.resetPassword == true)
                        }
                        inputProps={{ 'aria-label': 'controlled' }}
                        checked={
                          formValues.idLegalClient < 0
                            ? formValues.loginPossible
                            : formValues.passwordResetRequired
                        }
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) =>
                          setFormValues({
                            ...formValues,
                            passwordResetRequired: event.target.checked,
                          })
                        }
                      />
                    }
                    label='Mandant muss Passwort ändern'
                  />
                </Grid>
                <Grid item xs={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={
                          formValues.resetPassword !== undefined &&
                          formValues.resetPassword == true
                        }
                        inputProps={{ 'aria-label': 'controlled' }}
                        checked={formValues.loginPossible}
                        onChange={(
                          event: React.ChangeEvent<HTMLInputElement>
                        ) => {
                          if (event.target.checked) {
                            setFormValues({
                              ...formValues,
                              loginPossible: true,
                              passwordResetRequired: true,
                            } as ILegalClientFullObject);
                          } else {
                            setFormValues({
                              ...formValues,
                              loginPossible: false,
                            } as ILegalClientFullObject);
                          }
                        }}
                      />
                    }
                    label='Login möglich'
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Collapse>
      </Grid>
    </>
  );
};
